import { Stack, Typography, useTheme } from "@mui/material";
import { forwardRef } from "react";
import type { CalendarEventGroup } from "../../types";
import { EventCard } from "./EventCard";

interface EventGroupProps {
  group: CalendarEventGroup;
}

/**
 * One day's worth of events under a "Today" / "Tomorrow" / date heading. The
 * ref is the scroll anchor the day strip targets.
 */
export const EventGroup = forwardRef<HTMLDivElement, EventGroupProps>(
  ({ group }, ref) => {
    const theme = useTheme();

    return (
      <Stack ref={ref} gap="4px">
        <Typography
          variant="caption-2"
          sx={{ color: theme.palette.primary.main }}
        >
          {group.label}
        </Typography>
        {group.events.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </Stack>
    );
  },
);

EventGroup.displayName = "EventGroup";
